module.exports = __webpack_public_path__ + "static/img/5areaA_3.de01eaf.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/animal/5areaA_3.png
// module id = 824
// module chunks = 1